import moment from "moment";
import { getAuthData } from "../services/storage/LocalStorage";


export const getCurrentTimestamp = () => {
  return moment().valueOf();
};

export const currentTimeStamp = () => {
  return `${moment().format("hh:mm:ss A")} | Milliseconds: ${moment().valueOf()}`;
};

export const formatDate = (date, format = "YYYY-MM-DD") => {
  return moment(date).format(format);
};


export const calculateDifference = (date1, date2, unit = "days") => {
  return moment(date1).diff(moment(date2), unit);
};


export const addTime = (date, amount, unit = "days") => {
  return moment(date).add(amount, unit).toISOString();
};

export const isBefore = (date1, date2) => {
  return moment(date1).isBefore(moment(date2));
};


export const isAfter = (date1, date2) => {
  return moment(date1).isAfter(moment(date2));
};


export const formatDateWithTimeHM = (date) => {
  return moment(date).format("DD MMM YYYY | HH:mm [Hrs]");
};

//format 17 Sep 2024 | 08:00 Hrs
export const formatDateTimeWithDateTimeFormat = (dateString) => {
  if (!dateString) return;

  const { user: { userTimezone } = {} } = getAuthData?.() || {};
  const defaultUserTimezone = "Etc/UTC";

  const date = new Date(dateString);
  const timeZone = userTimezone || defaultUserTimezone;

  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone,
  };

  const formatted = date.toLocaleString("en-GB", options);
  const [datePart, timePart] = formatted.split(", ");
  return `${datePart} | ${timePart} Hrs`;
};

export const normalizeTimezone = (tz) => {
  if (!tz) return "Etc/UTC";
  // Remove any "(GMT+...)" part and trim spaces
  return tz.replace(/\(GMT[^\)]+\)/, '').trim();
};

export function getLocalTimezone() {
  try {
    // Modern browsers
    const tz = Intl?.DateTimeFormat?.().resolvedOptions?.().timeZone;

    if (tz && typeof tz === "string") {
      return tz;
    }
  } catch (err) {
    console.warn("Timezone detection failed:", err);
  }

  // Fallback (older browsers, IE, rare cases)
  return "UTC";
}


/** Formats Month label */
export const formatMonthLabel = (date) => {
  return date.format("MMMM YYYY");
};

/** Formats Day label */
export const formatDayLabel = (date) => {
  return date.format("dddd MMM DD");
};

/** Formats Week label — always Sunday → Saturday */
export const formatWeekLabel = (date) => {
  const start = date.clone().startOf("week");   // Sunday
  const end = date.clone().endOf("week");       // Saturday

  const sameMonth = start.month() === end.month();

  if (sameMonth) {
    return `${start.format("MMMM DD")} - ${end.format("DD")}`;
  }

  return `${start.format("MMMM DD")} - ${end.format("MMMM DD")}`;
};

/** Returns correct label for any view */
export const getLabelForView = (date, view) => {
  switch (view) {
    case "day": return formatDayLabel(date);
    case "week": return formatWeekLabel(date);
    case "month":
    default: return formatMonthLabel(date);
  }
};